import React from 'react'

const ErrorComponents = () => {
  return (
    <div>ErrorComponents</div>
  )
}

export default ErrorComponents